import React, { PropsWithChildren } from "react"

export const Text = (props: PropsWithChildren<Record<string, unknown>>): JSX.Element => {
  return <span>{props.children}</span>
}
